import { CustomerFormPage } from './CustomerFormPage';
export default CustomerFormPage;
